<template>
   <div>
      <div class=" container-fluid   ">
        <div class="llp-container-section  heightcontainer ">
       <top-header id="height2"></top-header>
      <main-menu id="height3"></main-menu>
      <!-- Start the code for this screen here -->
      <div id="activity" class="container-fluid menu-margin-top" style="padding-left:0px;padding-right:0px">
         <div>
            <nav class="navbar navbar-expand-lg  bg-info text-white">
               <span><b>{{headerMessage}}</b></span>
            </nav>
            <div v-if="saved">
               <center><span :style="msgcolor"><b>{{task.message}}</b></span></center>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  p-2 ">
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label class="col-form-label col-form-label-sm required">Salesperson Name</label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <select v-if="this.disableemployeedd" class="form-control input-sm" data-vv-name="Employee" v-validate="'required'" v-model.trim="task.empId"  disabled @change="getcolorcodes">
                     <option selected v-for="emp in employeelist" v-bind:value="emp.employeeId" v-bind:key="emp.employeeId" > {{ emp.firstName }} , {{ emp.lastName }} </option>
                  </select>
                <!--   <select v-else v-validate="'required'" class="form-control input-sm" data-vv-name="Employee" v-model.trim="task.empId"  @change="getcolorcodes()">

                     <option disabled  value=""> Select Employee </option>
                     <option selected v-for="emp in employeelist" v-bind:value="emp.employeeId" v-bind:key="emp.employeeId" > {{ emp.firstName }}  , {{ emp.lastName }} </option>
                  </select>-->
                   <!-- Admin and BO-->
                    <multiselect
    style="width:100%"
    v-else
    v-validate="'required'"
    data-vv-name="Employee"
    v-model="task.empId"
    @input="getcolorcodes()"
    :options="employeelist"
    placeholder="Select Employee"
   :value="employeelist.employeeId"
    :custom-label="displayFullName"
    selected="selected"
    id="statesdd">
  </multiselect>
                  <div v-if="errors.has('Employee')" class="alert-danger"> {{ errors.first('Employee') }} </div>
               </div><!--col end-->
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label class="col-form-label col-form-label-sm required">Activity Task</label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <select  v-validate="'required'" class="form-control input-sm" ref="activity"  @change="getcolorcodes();"  data-vv-name="Task Type" v-model.trim="task.selected"  >
                     <option disabled value="">Select a Task</option>
                     <option v-for="actTaskType in activityTaskTypes"   v-bind:key="actTaskType.key" v-bind:value="actTaskType.key" >{{actTaskType.value}} </option>
                  </select>
                  <div v-if="errors.has('Task Type')" class="alert-danger" > {{ errors.first('Task Type') }} </div>
               </div><!--col end-->
            </div><!--row end-->

              <div style="margin-top:1%">

   <button type = "button" @click ="setMyDateToToday" style="width:3%;margin-right:1%" class="btn-blue-save"><</button>

  <label>Start Of Week</label>

  <label  style="margin-left:1.5%">{{weekStart | moment("MM/DD/YYYY") }}</label>

  <label style="margin-left:3%">End Of Week</label>

  <label style="margin-left:1.5%">{{weekEnd | moment("MM/DD/YYYY") }}</label>

  <button type = "button" @click ="addADayToMyDate" style="width:3%;margin-left:1%" class="btn-blue-save">></button>

</div>
            <div  v-if="task.selected === 'EDV'">
               <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  p-2 ">
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                     <label class="col-form-label col-form-label-sm required">Select Dealer</label>
                  </div>
                  <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                     <multiselect
                        style="width:100%"
                        v-model="task.dealerName"
                        data-vv-as="Dealer"
                        v-validate="'required'"
                        :options="colorcodelist"
                        v-bind:value="colorcodelist.dealerName"
                        v-bind:key="colorcodelist.dealerId"
                        :custom-label="customLabel"
                        selected="selected"
                        name="edvDealer">
                     </multiselect>
                     <div v-if="errors.has('edvDealer')" class="alert-danger" > {{ errors.first('edvDealer') }} </div>
                  </div>
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                     <label  class="col-form-label col-form-label-sm required">Activity Type</label>
                  </div>
                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                     <select  v-model="task.edvactivityType" v-validate="'required'" class="form-control input-sm" name="edvactivityType"  data-vv-as="Activity Type" key="edvactivityType" >
                        <option disabled value="">Select Activity</option>
                        <option v-for="activity in activities" v-bind:value="activity.key" v-bind:key="activity.key">{{activity.value}}</option>
                     </select>
                     <div v-if="errors.has('edvactivityType')" class="alert-danger" > {{ errors.first('edvactivityType') }} </div>
                  </div>
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                     <label class="col-form-label col-form-label-sm">Dealer Activity Level</label>
                  </div>
                  <div class="col-12 col-md-12 d-flex align-items-center">
                     <label class="col-form-label col-form-label-sm">{{task.dealerName.dealerColorCode}}</label>
                  </div>
               </div>
               <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  p-2 ">
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                     <label class="required">Short Note</label>
                  </div>
                  <div class="col-12 col-lg-4 col-md-12 col-sm-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                     <textarea  v-model="task.shortNotes" v-validate="'required|max:80'" class=" form-control input-sm required" placeholder="Enter Notes" data-vv-as="Notes" key="edvNotes" name="edvNotes" rows="4" cols="60"  :maxlength="80"  spellcheck="true" ></textarea>
                     <div v-if="errors.has('edvNotes')" class="alert-danger" > {{ errors.first('edvNotes') }} </div>
                  </div>
               </div>
            </div>
            <div   v-if="task.selected === 'NDDV'" >
               <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  p-2 ">
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                     <label class="col-form-label col-form-label-sm required">Select Dealer  </label>
                  </div>
                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                     <input type="search" list="colorcodelist" class="form-control input-sm" v-validate="'required'"  placeholder="Enter Dealer Name"   name="nddvdealer"  v-model="task.dealerName" data-vv-as="Dealer Name" >
                     <datalist id="colorcodelist">
                        <option  v-for="colorcode in colorcodelist"  v-bind:value="colorcode.dealerName" v-bind:key="colorcode.dealerId">{{colorcode.dealerName}}</option>
                     </datalist>
                     <div v-if="errors.has('nddvdealer')" class="alert-danger" > {{ errors.first('nddvdealer') }} </div>
                  </div>
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                     <label  class="col-form-label col-form-label-sm required">Activity Type</label>
                  </div>
                  <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                     <select  class="form-control input-sm" v-model="task.nddvactivityType" v-validate="'required'" name= "nddvactivityType" key= "nddvactivityType"  data-vv-as="Activity Type" >
                        <option disabled value="">Select Activity</option>
                        <option v-for="activity in activities" v-bind:value="activity.key" v-bind:key="activity.key">{{activity.value}}</option>
                     </select>
                     <div v-if="errors.has('nddvactivityType')" class="alert-danger" > {{ errors.first('nddvactivityType') }} </div>
                  </div>
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                     <label class="col-form-label col-form-label-sm">Dealer Activity Level</label>
                  </div>
                  <div class="col-12 col-md-12 d-flex align-items-center">
                     <label class="col-form-label col-form-label-sm">{{getdealerColorCode}}</label>
                  </div>
               </div>
               <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  p-2 ">
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                     <label class="col-form-label col-form-label-sm required">Short Note</label>
                  </div>
                  <div class="col-12 col-lg-4 col-md-12 col-sm-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                     <textarea  v-model="task.shortnotes"   placeholder="Enter Notes" class=" form-control input-sm required"  v-validate="'required'" key= "nddvnotes" name= "nddvnotes" data-vv-as="Notes"  rows="4" cols="60"    :maxlength="80"  spellcheck="true" ></textarea>
                     <div v-if="errors.has('nddvnotes')" class="alert-danger" > {{ errors.first('nddvnotes') }} </div>
                  </div>
               </div>
            </div>
            <div  v-if="task.selected === 'COAU'">
               <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  p-2 ">
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                     <label class="col-form-label col-form-label-sm required">Enter Dealer name</label>
                  </div>
                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                     <input type="textbox"  class="form-control input-sm" placeholder="Enter Dealer Name" v-validate="'required'" name="coaudealer" key="coaudealer" v-model ="task.dealerName"  data-vv-as="Dealer" >
                     <div v-if="errors.has('coaudealer')" class="alert-danger" > {{ errors.first('coaudealer') }} </div>
                  </div>
               </div>
               <br>
               <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  p-2 ">
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                     <label >Bussiness Title</label>
                  </div>
                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                     <input type="textbox" class="form-control input-sm" placeholder="Enter Bussiness Title" v-model="task.businessTitle" >
                  </div>
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                     <label class="col-form-label col-form-label-sm" >Name </label>
                  </div>
                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                     <input type="textbox" class="form-control input-sm" placeholder="Enter Bussiness Name" v-model="task.businessFullName"  >
                  </div>
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                     <label class="col-form-label col-form-label-sm" >Contact Number</label>
                  </div>
                  <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                     <input id="pnum"
                        class="form-control input-sm"
                        placeholder="Enter Mobile Number"
                        v-model="task.contactNumber"
                        title="Please enter 10 digits"
                        maxlength="10"
                        v-validate="'min:10|max:14'" data-vv-name="Cell Phone"
                        @input="formatCellPhoneNumber"
                        @blur="formatCellPhoneNumber"
                        />
                  </div>
               </div>
               <br>
               <div  class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  p-2 ">
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                     <label class="col-form-label col-form-label-sm required">Short Note</label>
                  </div>
                  <div class="col-12 col-lg-4 col-md-12 col-sm-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                     <textarea v-model="task.shortNote" name="coaunotes" class=" form-control input-sm"  key="coaunotes" placeholder="Enter Notes"  v-validate="'required|max:80'" rows="4" cols="60" data-vv-as="Notes"  :maxlength="80"  spellcheck="true" ></textarea>
                     <div v-if="errors.has('coaunotes')" class="alert-danger" > {{ errors.first('coaunotes') }} </div>
                  </div>
               </div>
            </div>
            <div  v-if="task.selected === 'ET'">
               <div class ="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  p-2 ">
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                     <label class="col-form-label col-form-label-sm required">Event Type</label>
                  </div>
                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                     <input list="eventlist" v-validate="'required'" class="form-control input-sm" placeholder="Select Event Type"  id="browsers"  name="browser" key="browser"   v-model="eventType" data-vv-as="Event Type" >
                     <datalist id="eventlist">
                        <option  v-for="event in eventlist" v-bind:value="event.value" v-bind:key="event.key">{{event.value}}</option>
                     </datalist>
                     <div v-if="errors.has('browser')" class="alert-danger" > {{ errors.first('browser') }} </div>
                  </div>
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                     <label class="col-form-label col-form-label-sm">Event Category</label>
                  </div>
                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                     <select v-model="task.eventCategory" class="form-control input-sm">
                        <option disabled  value="">Select Category</option>
                        <option v-for="Event in Events" v-bind:value="Event.value" v-bind:key="Event.key">{{Event.value}}</option>
                     </select>
                  </div>
                  </div>
                  <div class ="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  p-2 ">
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                     <label class="col-form-label col-form-label-sm required">Short Note</label>
                  </div>
                  <div class="col-12 col-lg-4 col-md-12 col-sm-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                     <textarea  v-model="task.shortnote"  name="etnotes" key="etnotes" class=" form-control input-sm" placeholder="Enter Notes" v-validate="'required|max:80'" rows="4" cols="60" data-vv-as="Notes"  :maxlength="80"  spellcheck="true" ></textarea>
                     <div v-if="errors.has('etnotes')" class="alert-danger" > {{ errors.first('etnotes') }} </div>
                  </div>
               </div>
            </div>
            <div v-if="task.selected === 'DSRT'">
               <div>
                  <div class ="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  p-2 ">
                     <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                        <label class="col-form-label col-form-label-sm required">Deal Support</label>
                     </div>
                     <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                        <select  v-model="task.dealerSupport" class="form-control input-sm"  name="dsrtDealer" key="dsrtDealer" v-validate="'required'"   data-vv-as="Deal Support" >
                           <option disabled value="">Select</option>
                           <option v-for="deal in deals" v-bind:value="deal.value" v-bind:key="deal.key" >{{deal.value}}
                           </option>
                        </select>
                        <div v-if="errors.has('dsrtDealer')" class="alert-danger" > {{ errors.first('dsrtDealer') }} </div>
                     </div>
                     <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                        <label class="col-form-label col-form-label-sm">Trackers,PaperWork Etc</label>
                     </div>
                     <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3" >
                        <input type="text" placeholder="Enter Trackers,PaperWork Etc" class="form-control input-sm" v-model="task.trackerPaperWork" >
                     </div>
                  </div>
                   <div class ="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  p-2 ">
                     <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                        <label class="col-form-label col-form-label-sm required">Short Note</label>
                     </div>
                     <div class="col-12 col-lg-4 col-md-12 col-sm-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                        <textarea  v-model="task.ShortNotes" placeholder="Enter Notes" class="form-control input-sm " key= "dsrtnotes" name="dsrtnotes" v-validate="'required|max:80'"  data-vv-as="Notes" rows="4" cols="60"   :maxlength="80"  spellcheck="true" ></textarea>
                        <div v-if="errors.has('dsrtnotes')" class="alert-danger" > {{ errors.first('dsrtnotes') }} </div>
                     </div>
                  </div>
               </div>
            </div>
            <center>
                     <button type="submit" @click="addtasks" class="btn btn-secondary ml-3"> Add </button>
                     <button type="submit" @click="resetdata" class="btn btn-secondary ml-3"> Reset </button>
            </center>
            <br>
            <div  class="llp-container-section">
               <nav class="navbar navbar-expand-lg  bg-info text-white">
                  <b>Display Tasks</b>
               </nav>
            </div>

            <!-- Table Data start-->
            <div class="row mt-2 justify-content-center mb-5">
               <div class="col">
                  <div class="table-responsive-sm table-responsive-sm mb-5 tbl-update-dealer">
                  <v-table
                    id="tasklist"
                    :data="taskList"
                    class="table table-sm table-bordered table-striped"
                  >
                  <thead class="table-month-header-blue wrap-text" slot="head">
                      <v-th sortKey="startOfWeek">Schedule Week</v-th>
                      <v-th sortKey="employee.firstName">Salesperson Name</v-th>
                      <v-th sortKey="activityTaskX">Activity Task</v-th>
                      <v-th sortKey="dealerName">Dealer Name</v-th>
                      <v-th sortKey="eventType">Event Type</v-th>
                      <v-th sortKey="shortNotes">Short Note</v-th>
                      <v-th sortKey="agentTaskId">Action</v-th>
                        </thead>
                        <tbody slot="body" slot-scope="{ displayData }">
                           <tr v-for="(task,dindex) in displayData" :key="dindex">
                              <td>{{task.startOfWeek| moment("MM/DD/YYYY")}} to {{task.endOfWeek| moment("MM/DD/YYYY")}}</td>
                              <td>{{task.employee.firstName}},{{task.employee.lastName}}</td>
                              <td>{{task.activityTaskX}}</td>
                              <td>{{task.dealerName}}</td>
                              <td>{{task.eventType}}</td>
                              <td>{{task.shortNotes}}</td>
                              <td> <button class="btn btn-secondary"  type="submit" @click="deleteActivity(task.agentTaskId)">Delete</button>
                              </td>
                           </tr>
                        </tbody>
                     </v-table>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- End of the code for this screen here -->
      <bottom-footer></bottom-footer>
        </div>
      </div>
   </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import manageSourceSvc from '../js/http-managesource'
import httpaddtask from '../js/http-addtask'
import moment from 'moment'
import util from '../js/common-utils.js'
import httpEmployee from '../js/http-employee'
import multiselectcss from '@/css/vue-multiselect.min.css'

export default {
  components: { MainMenu,
    TopHeader,
    BottomFooter
  },
  name: 'AddTask',

  data () {
    return {
      colorcodelist: [],
      eventType: '',
      disableemployeedd: 'false',
      weekStart: moment().weekday(0),
      weekEnd: moment().weekday(6),
      weekstart: moment().weekday(0),
      weekend: moment().weekday(6),
      activityTaskTypes: [
        { key: 'EDV', value: 'Existing Dealer Visits' },
        { key: 'NDDV', value: 'New/Dormant Dealer Visits' },
        { key: 'ET', value: 'Events' },
        { key: 'COAU', value: 'Conferences/Auctions' },
        { key: 'DSRT', value: 'Deal Support' }
      ],
      activities: [
        { key: 'In person', value: 'In person' },
        { key: 'Call', value: 'Call' }
      ],
      Events: [
        { key: 'Attend Local Enthusiast Events', value: 'Attend Local Enthusiast Events' },
        { key: 'Attend Conferences And Auctions', value: 'Attend Conferences And Auctions' }
      ],
      eventlist: [
        { key: 'Cars And Coffee', value: 'Cars And Coffee' }

      ],
      deals: [
        { key: 'Deliver Tracker', value: 'Deliver Tracker' },
        { key: 'Support PaperWork', value: 'Support PaperWork' },
        { key: 'Field Dealer Questions', value: 'Field Dealer Questions' },
        { key: 'Liaison', value: 'Liaison' }
      ],

      colheaders: [
        { header: 'Schedule Week' },
        { header: 'Salesperson Name' },
        { header: 'Activity Task' },
        { header: 'Dealer Name' },
        { header: 'Event Type' },
        { header: 'Short Note' },
        { header: 'Action' }
      ],

      // offshore code  anything below
      headerMessage: 'Add Task',
      name: '',
      taskList: [],
      activitytask: '',
      dealer: '',
      activity: '',
      task: this.initializedata(),
      users: [],
      employeelist: [],
      dealerlists: [],
      // messages:['VisitExistingDealers','visit New/Dormant Dealers','Identify New Dealers','Events','Deal Support'],
      tasklist: [],
      requiredfieldcontent: '*',
      saved: false,
      failure: false,
      schActForDisplay: [],
      // failureMessage:"Please fill all mandatory fields",
      nmhighlightobject: {
        border: ''
      },
      msgcolor: {
        color: 'black'
      }
    }
  },

  methods: {
    displayFullName (option) {
      return `${option.firstName} ${option.middleName != null && option.middleName.length != 0 ? ',' + option.middleName : ''} ,${option.lastName != null && option.lastName.length != 0 ? option.lastName : ''}`
    },
    initializedata () {
      return {
        message: 'Successfully added into the system',
        edvactivityType: '',
        nddvactivityType: '',
        activityTaskD: '',
        employeeId: '',
        agentTaskNotes: '',
        dealerId: '',
        businessTitle: '',
        contactNumber: '',
        eventType: '',
        eventCategory: '',
        dealerSupport: '',
        trackerPaperWork: '',
        shortNotes: '',
        shortnotes: '',
        shortNote: '',
        shortnote: '',
        ShortNotes: '',
        selected: '',
        dealerName: '',
        agentTaskId: '',
        dealercategory: '',

        empId: (this.$session.get('user_role') == 'SR') ? this.$session.get('employee_id') : ''
      }
    },
    resetactivitytype () {
      this.task.dealerName = ''
    },
    dropdowndefaultselect () {
      if (this.eventlist.length <= 1) {
        this.eventType = 'Cars And Coffee'
      }
    },
    getcolorcodes () {
      var employeeIdData
      var changecolorcode
      if (this.task.selected === 'EDV') {
        changecolorcode = 'Amber,Green'
      } else if (this.task.selected === 'NDDV') {
        changecolorcode = 'Red'
      }

      if (this.$session.get('user_role') == 'SR') {
        employeeIdData = this.task.empId
      } else {
        employeeIdData = this.task.empId.employeeId
      }
      if (this.task.selected === 'EDV' && employeeIdData || this.task.selected === 'NDDV' && employeeIdData) {
        httpEmployee.get('/employee/dealergrade/' + parseInt(employeeIdData), { params: {

          colorCodes: changecolorcode
        }
        }).then(response => {
          this.colorcodelist = response.data
          // console.log(JSON.stringify(this.colorcodelist))
        })
      }
      if (this.task.selected === 'EDV' || this.task.selected === 'NDDV') {
        this.resetactivitytype()
      }
    },
    formatCellPhoneNumber: function (event) {
      var phone = this.task.contactNumber
      phone = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
      this.task.contactNumber = phone
    },

    customLabel (option) {
      return `${option.dealerName}`
    },
    customLabels (option) {
      return `${option.firstName},${option.lastName}`
    },

    displayTasks: function () {
      var viewTaskPayload = {

        'fromDate': moment(this.weekStart),
        'toDate': moment(this.weekEnd)

      }
      httpaddtask.post('/searchtasks', viewTaskPayload).then(response => {
        // console.log(moment(this.weekStart))
        // console.log(moment(this.weekEnd))

        this.taskList = response.data
        // console.log("Activity to be saved:"+ JSON.stringify( this.taskList))
      })
    },
    updateDealer () {
      // get assigned dealer list

      var employeeIdData
      if (this.$session.get('user_role') == 'SR') {
        employeeIdData = this.task.empId
      } else {
        employeeIdData = this.task.empId.employeeId
      }

      this.dealerlists = []
      httpEmployee.get('/employee/' + parseInt(employeeIdData)).then(response => {
   					 for (var i = 0; i < response.data.length; i++) {
   						var employeeobject = response.data[i]
   						for (var i = 0; i < employeeobject.empBusinessCoverageAreas.length; i++) {
   							var empbuscovarea = employeeobject.empBusinessCoverageAreas[i]
   							this.dealerlists.push({
   								'dealerId': empbuscovarea.id.dealerId,
   								'dealerName': empbuscovarea.ddealerInfo.dealerName
   							})
   						}
   					 }
      }).catch(e => { console.log(e) })
    },
    // save data
    addtasks (e) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          var date = new Date()
          var currentDate = new Date()

          var employeeIdData
          if (this.$session.get('user_role') == 'SR') {
            employeeIdData = this.task.empId
          } else {
            employeeIdData = this.task.empId.employeeId
          }
          // save existing dealer
          if (this.task.selected === 'EDV') {
            let newContact = {
              dealerName: this.task.dealerName.dealerName,
              startOfWeek: util.formatDateMoment(this.weekStart),
              endOfWeek: util.formatDateMoment(this.weekEnd),
              activityType: this.task.edvactivityType,
              activityTaskD: this.task.selected,
              employeeId: employeeIdData,
              dealerId: this.task.dealerId,
              activityTaskX: 'Existing Dealer Visits',
              shortNotes: this.task.shortNotes,
              dealerActivityLevel: this.task.dealerName.dealerColorCode,
              'creationD': currentDate, // moment().format("MM/dd/yyyy"),
              'creationUserI': this.$session.get('user_id')
            }
            httpaddtask.post('/addTask', newContact).then(response => {
              var status = response.data
              console.log('Successfully saved:' + JSON.stringify(status))
              if (status == 'CREATED') {
                this.saved = true
                this.task.message = 'Successfully added into the system'

                // get add task
                this.retriveSalesRepData()
                // reset form
                this.errors.clear()
                this.$validator.reset()
                this.task = this.initializedata()
                this.colorcodelist = []
              }
            })
              .catch(e => {
                console.log('Error in save data: ' + e)
                this.failure = true
              })
          } // end if

          // save New/Dormant Dealers Visit
          if (this.task.selected === 'NDDV') {
            let newDealer = {
              startOfWeek: util.formatDateMoment(this.weekStart),
              endOfWeek: util.formatDateMoment(this.weekEnd),
              dealerName: this.task.dealerName,
              employeeId: employeeIdData,
              activityType: this.task.nddvactivityType,
              activityTaskD: this.task.selected,
              shortNotes: this.task.shortnotes,
              activityTaskX: 'New/Dormant Dealer Visits',
              dealerActivityLevel: this.colorcodelist[0].dealerColorCode,
              'creationD': currentDate, // moment().format("MM/dd/yyyy"),
              'creationUserI': this.$session.get('user_id')
            }

            httpaddtask.post('/addTask', newDealer).then(response => {
              var status = response.data
              console.log('Successfully saved:' + JSON.stringify(status))
              if (status == 'CREATED') {
                this.saved = true
                this.task.message = 'Successfully added into the system'

                // get add task
                this.retriveSalesRepData()
                // reset form
                this.errors.clear()
                this.$validator.reset()
                this.task = this.initializedata()
                this.colorcodelist = []
              }
            })
              .catch(e => {
                console.log('Error in save data: ' + e)
                this.failure = true
              })
          }// end if

          // save events
          if (this.task.selected === 'ET') {
            let events = {
              startOfWeek: util.formatDateMoment(this.weekStart),
              endOfWeek: util.formatDateMoment(this.weekEnd),
              employeeId: employeeIdData,
              activityTaskD: this.task.selected,
              eventType: this.eventType,
              eventCategory: this.task.eventCategory,
              shortNotes: this.task.shortnote,
              activityTaskX: 'Events',
              'creationD': currentDate, // moment().format("MM/dd/yyyy"),
              'creationUserI': this.$session.get('user_id')
            }
            httpaddtask.post('/addTask', events).then(response => {
              var status = response.data
              console.log('Successfully saved:' + JSON.stringify(status))
              if (status == 'CREATED') {
                this.saved = true
                this.task.message = 'Successfully added into the system'

                // get add task
                this.retriveSalesRepData()
                // reset form
                this.errors.clear()
                this.$validator.reset()
                this.task = this.initializedata()
              }
            })
              .catch(e => {
                console.log('Error in save data: ' + e)
                this.failure = true
              })
          }

          // save Conferences/Auctions
          if (this.task.selected === 'COAU') {
            let Conferences = {
              startOfWeek: util.formatDateMoment(this.weekStart),
              endOfWeek: util.formatDateMoment(this.weekEnd),
              employeeId: employeeIdData,
              activityTaskD: this.task.selected,
              dealerName: this.task.dealerName,
              businessTitle: this.task.businessTitle,
              businessFullName: this.task.businessFullName,
              contactNumber: this.task.contactNumber,
              activityTaskX: 'Conferences/Auctions',
              shortNotes: this.task.shortNote,
              'creationD': currentDate, // moment().format("MM/dd/yyyy"),
              'creationUserI': this.$session.get('user_id')
            }
            httpaddtask.post('/addTask', Conferences).then(response => {
              var status = response.data
              console.log('Successfully saved:' + JSON.stringify(status))
              if (status == 'CREATED') {
                this.saved = true
                this.task.message = 'Successfully added into the system'

                // get add task
                this.retriveSalesRepData()
                // reset form
                this.errors.clear()
                this.$validator.reset()
                this.task = this.initializedata()
              }
            })
              .catch(e => {
                console.log('Error in save data: ' + e)
                this.failure = true
              })
          }

          // for dealerSupport save
          if (this.task.selected === 'DSRT') {
            let newContacts = {
              startOfWeek: util.formatDateMoment(this.weekStart),
              endOfWeek: util.formatDateMoment(this.weekEnd),
              employeeId: employeeIdData,
              dealerSupport: this.task.dealerSupport,
              trackerPaperWork: this.task.trackerPaperWork,
              shortNotes: this.task.ShortNotes,
              activityTaskD: this.task.selected,
              activityTaskX: 'Deal Support',
              'creationD': currentDate, // moment().format("MM/dd/yyyy"),
              'creationUserI': this.$session.get('user_id')
            }

            httpaddtask.post('/addTask', newContacts).then(response => {
              var status = response.data
              console.log('Successfully saved:' + JSON.stringify(status))
              if (status == 'CREATED') {
                this.saved = true
                this.task.message = 'Successfully added into the system'

                // get add task
                this.retriveSalesRepData()
                // reset form
                this.errors.clear()
                this.$validator.reset()
                this.task = this.initializedata()
              }
            })
              .catch(e => {
                console.log('Error in save data: ' + e)
                this.failure = true
              })
          }
        }
      } // end if
      )
    },

    // delete data from database
    deleteActivity (agentTaskId) {
      httpaddtask.delete('/deletetask/' + agentTaskId).then(response => {
        var status = response.data
        console.log('Deleted resonse' + status)
        this.$validator.reset()
        if (status == 'NO_CONTENT') {
          // TODO - Find a way to remove element from array with specific ID OR make Retreive Call to get Fresh Data
          this.retriveSalesRepData()
        } else {
          // message that failed to delete?
          console.log('Error deleting activity')
        }
      })
    },
    resetdata () {
      this.task = this.initializedata()
      this.colorcodelist = []
    },
    // subtracting -7 days
    setMyDateToToday () {
      if (this.weekStart > this.weekstart) {
        this.newdate = moment(this.weekStart).subtract('days', 7)
        this.weekStart = this.newdate
      }
      if (this.weekEnd > this.weekend) {
        this.newdate = moment(this.weekEnd).subtract('days', 7)
        this.weekEnd = this.newdate
        if (this.$session.get('user_role') == 'SR') {
          // console.log(this.$session.get("user_role") == 'SR')
          this.retriveSalesRepData()
        } else {
          // console.log("exit")
          this.displayTasks()
        }
      }
    },
    // adding week
    addADayToMyDate () {
      this.newdate = moment(this.weekStart).add('days', 7)
      this.weekStart = this.newdate
      this.newdate = moment(this.weekEnd).add('days', 7)
      this.weekEnd = this.newdate
      if (this.$session.get('user_role') == 'SR') {
        // console.log(this.$session.get("user_role") == 'SR')
        this.retriveSalesRepData()
      } else {
        this.displayTasks()
      }
    },
    // get employee list
    retrivePageloadData: function () {
      // get tasks
      this.retriveSalesRepData()
    },

    retriveSalesRepData: function () {
      if (this.$session.get('user_role') == 'SR') {
        httpaddtask.get('/employee/' + this.$session.get('employee_id')).then(response => {
          if (response.data.length != 0) {
            var viewTaskPayload = {
              repId: this.$session.get('employee_id'),
              fromDate: moment(this.weekStart),
              toDate: moment(this.weekEnd)
            }
            httpaddtask.post('/searchtasks', viewTaskPayload).then(response => {
              this.taskList = response.data
              // console.log("Activity to be saved:"+ JSON.stringify( this.taskList))
            })
          } else {
            this.taskList = []
          }
        }).catch(e => {
          console.log('Failed to get Tasks for Sales Rep')
          this.taskList = []
        })
      } else {
        this.displayTasks()
      }
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#activity').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    },

    fetchdata: function () {
      if (this.$session.get('user_role') == 'SR') {
        // console.log("username"+ this.$session.get("user_role") )
        this.employeelist = [
          { 'employeeId': this.$session.get('employee_id'),
            'firstName': this.$session.get('first_name'),
            'lastName': this.$session.get('last_name')
          }
        ]
        this.task.empId = this.$session.get('employee_id')

        // disable the Dropdown
        this.disableemployeedd = true
        this.updateDealer()
      } else {
        this.disableemployeedd = false
        // create objet
        let searchEmployee = {
          'firstName': '',
          'lastName': '',
          'roleType': '', // All Employees
          'statusCode': ''
        }
        httpEmployee.post('/employee/search/', searchEmployee).then(response => {
          this.employeelist = response.data
        })
          .catch(e => {
            console.log('Failed to load salesperson:' + e)
          })
      }
      this.retrivePageloadData()
    }
  },

  computed: {
    getdealerColorCode () {
      if (this.task.dealerName != '') {
        return this.colorcodelist[0].dealerColorCode
        console.log(this.colorcodelist[0].dealerColorCode)
      }
    },
    filteredPeople: function () {
      var startofWeekonScreen = moment(this.weekStart).format('MM/DD/YYYY')
      var endofWeekonScreen = moment(this.weekEnd).format('MM/DD/YYYY')

      return this.tasklist.filter(function (tasks) {
        return (startofWeekonScreen === moment(tasks.startOfWeek).format('MM/DD/YYYY') && endofWeekonScreen === moment(tasks.endOfWeek).format('MM/DD/YYYY'))
        // console.log("week is"+ startofWeekonScreen )
      })
    },
    sortedDealers: function () {
      return this.dealerlists.sort((a, b) => { return a.dealerName > b.dealerName ? 1 : -1 })
    }
  },

  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },

  mounted: function () {
    this.fetchdata()
    this.myFunction()
    this.menuheight()
    this.dropdowndefaultselect()
    this.retriveSalesRepData()
  }
}
</script>
<style scoped>   </style>
